import {writable} from 'svelte/store';

export const tabActive = writable('Simulation du salaire');

export function setActiveTab(i) {
    tabActive.set(i);
}